'use client';

import { cn } from '@/lib/utils';

interface LiveDotProps {
  className?: string;
  color?: 'red' | 'green' | 'gold';
  size?: number;
}

const COLORS = {
  red: { core: '#ef4444', halo: 'rgba(239, 68, 68, 0.55)' },
  green: { core: '#22c55e', halo: 'rgba(34, 197, 94, 0.55)' },
  gold: { core: '#facc15', halo: 'rgba(250, 204, 21, 0.55)' },
} as const;

export function LiveDot({ className, color = 'red', size = 8 }: LiveDotProps) {
  const c = COLORS[color];
  return (
    <span
      className={cn('relative inline-flex items-center justify-center', className)}
      style={{ width: size, height: size }}
      aria-hidden
    >
      <span
        className="absolute inset-0 rounded-full"
        style={{
          background: c.halo,
          animation: 'lobby-live-pulse 1.6s ease-in-out infinite',
        }}
      />
      <span
        className="relative rounded-full"
        style={{
          width: size,
          height: size,
          background: c.core,
          boxShadow: `0 0 6px ${c.halo}`,
        }}
      />
    </span>
  );
}
